import { Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { OidcCallbackComponent } from './components/oidc-callback/oidc-callback.component';
import { TnrAuthGuard } from './guards/tnr-auth.guard';
import { LoginComponent } from './components/login/login.component';
import { NoAccessComponent } from './components/no-access/no-access.component';
import { UnderConstructionComponent } from './components/under-construction/under-construction.component';
import { AdminModuleGuard } from './guards/admin-module.guard';
import { ColabAuthGuard } from './guards/colab-auth.guard';
import { ModuleAccessGuard, MODULE_CODE_ROUTE_DATA_KEY } from './guards/module-access.guard';
import {
  AJM_MODULE_CODE,
  JTM_MODULE_CODE,
  DSM_MODULE_CODE,
  WVT_MODULE_CODE,
  BDX_MODULE_CODE,
  MRG_MODULE_CODE,
  TID_MODULE_CODE
} from './constants/module-codes';
import { FILL_VIEWPORT_ROUTE_DATA_KEY } from './constants/route-data';

export const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
    canActivate: [TnrAuthGuard, ColabAuthGuard]
  },
  {
    path: 'auth/signin-oidc',
    component: OidcCallbackComponent
  },
  {
    path: 'auth/login',
    component: LoginComponent
  },
  {
    path: 'no-access',
    component: NoAccessComponent
  },
  {
    path: 'under-construction',
    component: UnderConstructionComponent,
    canActivate: [TnrAuthGuard, ColabAuthGuard]
  },
  // {
  //   path: 'example',
  //   loadChildren: () => import('./modules/example/example.module').then((m) => m.ExampleModule),
  //   canActivateChild: [TnrAuthGuard]
  // },
  {
    path: 'automated-job-matching',
    loadChildren: () => import('./modules/automated-job-matching/ajm.module').then((m) => m.AutomatedJobMatchingModule),
    canActivateChild: [TnrAuthGuard, ModuleAccessGuard],
    data: { [MODULE_CODE_ROUTE_DATA_KEY]: AJM_MODULE_CODE }
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.module').then((m) => m.AdminModule),
    canActivateChild: [TnrAuthGuard, AdminModuleGuard]
  },
  {
    path: 'job-title-matching',
    loadChildren: () => import('./modules/job-title-matching/job-title-matching.module').then((m) => m.JobTitleMatchingModule),
    canActivateChild: [TnrAuthGuard, ModuleAccessGuard],
    data: { [MODULE_CODE_ROUTE_DATA_KEY]: JTM_MODULE_CODE, [FILL_VIEWPORT_ROUTE_DATA_KEY]: true }
  },
  {
    path: 'dataset-manager',
    loadChildren: () => import('./modules/dataset-manager/dataset-manager.module').then((m) => m.DatasetManagerModule),
    canActivateChild: [TnrAuthGuard, ModuleAccessGuard],
    data: { [MODULE_CODE_ROUTE_DATA_KEY]: DSM_MODULE_CODE, [FILL_VIEWPORT_ROUTE_DATA_KEY]: true }
  },
  {
    path: 'job-redesign-toolkit',
    loadChildren: () =>
      import('./modules/job-redesign-toolkit/job-redesign-toolkit.module').then((m) => m.JobRedesignToolkitModule),
    canActivateChild: [TnrAuthGuard, ModuleAccessGuard],
    data: { [MODULE_CODE_ROUTE_DATA_KEY]: WVT_MODULE_CODE, [FILL_VIEWPORT_ROUTE_DATA_KEY]: true }
  },
  {
    path: 'boardex-dashboard',
    loadChildren: () => import('./modules/boardex-dashboard/boardex-dashboard.module').then((m) => m.BoardexDashboardModule),
    canActivateChild: [TnrAuthGuard, ModuleAccessGuard],
    data: { [MODULE_CODE_ROUTE_DATA_KEY]: BDX_MODULE_CODE, [FILL_VIEWPORT_ROUTE_DATA_KEY]: true }
  },
  {
    path: 'merge-link',
    loadChildren: () => import('./modules/merge-link/merge-link.module').then((m) => m.MergeLinkModule),
    canActivateChild: [TnrAuthGuard, ModuleAccessGuard],
    data: { [MODULE_CODE_ROUTE_DATA_KEY]: MRG_MODULE_CODE }
  },
  {
    path: 'talent-intelligence',
    loadChildren: () => import('./modules/talent-intelligence/talent-intelligence.module').then((m) => m.TalentIntelligenceModule),
    canActivateChild: [TnrAuthGuard, ModuleAccessGuard],
    data: { [MODULE_CODE_ROUTE_DATA_KEY]: TID_MODULE_CODE, [FILL_VIEWPORT_ROUTE_DATA_KEY]: true }
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ''
  }
];
